import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const ContextSelection = ({onContextSelected, variant="standard", width=280, defaultContext=''}) => {
  const [contextSelected, setContextSelected] = useState(defaultContext);

  useEffect(() => {
    if(contextSelected && typeof onContextSelected === 'function'){
      onContextSelected(contextSelected);
    }
  }, [contextSelected, onContextSelected]);

  return (
    <FormControl sx={{fontSize: 12}} fullWidth>
      {variant !== 'standard' ? <InputLabel size="small" id="context-select-label">Context</InputLabel>:null}
      <Select 
        size="small"
        labelId="context-select-label"
        value={contextSelected}
        label="Library"
        variant={variant}
        onChange={(e) => setContextSelected(e.target.value)}
        sx={{ padding: '4px 6px', fontSize: 14 }}
        // disable Underline
      >
        <MenuItem value="ADMIN">Admin</MenuItem>
        <MenuItem value="VENDOR">Vendor</MenuItem>
        <MenuItem value="USER">User</MenuItem>
      </Select>
    </FormControl>
  );
}
 
export default React.memo(ContextSelection);
